export default "/_next/static/chunks/fonts/Muli-SemiBold-eb776453ac0f1d4c2ce040cbd1f4dd4a.ttf";